module.exports = __webpack_public_path__ + "img/fastfilling.e9fabe10.svg";